export default "__VITE_ASSET__DnFvvaiI__"